import Icon from '../components/Icon.vue'

Icon.register({
  'grin-squint': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM281.8 197.7c-7.7 4.7-7.7 15.9 0 20.6l80 48c11.5 6.8 24.1-7.6 15.4-18l-33.6-40.3 33.6-40.3c8.6-10.3-3.8-24.9-15.4-18zM118.8 167.7l33.6 40.3-33.6 40.3c-8.6 10.4 3.9 24.8 15.4 18l80-48c7.8-4.7 7.8-15.9 0-20.6l-80-48c-11.6-6.9-24 7.7-15.4 18zM248 432c60.6 0 134.5-38.3 143.8-93.3 1.9-11.7-9.2-21.6-20.7-17.9-30.2 9.7-75.1 15.2-123.1 15.2s-92.9-5.5-123.1-15.2c-11.3-3.7-22.7 6-20.7 17.9 9.3 55 83.2 93.3 143.8 93.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grin-squint.js
// module id = 1407
// module chunks = 0